import React from "react";
import { useForm } from "@formspree/react";
import { Trans, useTranslation } from "react-i18next";
import contactUsService from "services/ContactUs";
import Form from "components/composite/Form";
import { Link, Navigate } from "react-router-dom";
import { useLocalizedPath } from "i18n/LanguageContext";
import { paths } from "constants";
import * as yup from "yup";

const ContactUsForm = () => {
  const [state, handleSubmit] = useForm(contactUsService.formSpreeId);
  const { t } = useTranslation(["contactUs", "forms"]);
  const localize = useLocalizedPath();

  const fields = [
    {
      id: "firstName",
      value: "",
      label: t("forms:fields.firstName.label"),
      placeholder: t("forms:fields.firstName.placeholder"),
      required: true,
    },
    {
      id: "lastName",
      value: "",
      label: t("forms:fields.lastName.label"),
      placeholder: t("forms:fields.lastName.placeholder"),
      required: true,
    },
    {
      id: "companyName",
      value: "",
      label: t("forms:fields.companyName.label"),
      placeholder: t("forms:fields.companyName.placeholder"),
      required: true,
    },
    {
      id: "phoneNumber",
      value: "",
      label: t("forms:fields.phoneNumber.label"),
      placeholder: t("forms:fields.phoneNumber.placeholder"),
      required: true,
    },
    {
      fullSize: true,
      id: "companyEmail",
      value: "",
      label: t("forms:fields.companyEmail.label"),
      placeholder: t("forms:fields.companyEmail.placeholder"),
      required: true,
      type: "email",
    },
    {
      fullSize: true,
      id: "message",
      value: "",
      label: t("forms:fields.message.label"),
      placeholder: "",
      required: true,
      type: "textarea",
    },
  ];

  const validations = {
    firstName: yup
      .string(t("forms:validation.firstName"))
      .required(t("forms:validation.firstName"))
      .min(2, t("forms:validation.firstNameMin")),
    lastName: yup
      .string(t("forms:validation.lastName"))
      .required(t("forms:validation.lastName"))
      .min(2, t("forms:validation.lastNameMin")),
    companyName: yup
      .string(t("forms:validation.companyName"))
      .required(t("forms:validation.companyName"))
      .min(2, t("forms:validation.companyNameMin")),
    phoneNumber: yup
      .string(t("forms:validation.phone"))
      .matches(
        // eslint-disable-next-line
        /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
        t("forms:validation.phonePattern")
      )
      .required(t("forms:validation.phone")),
    companyEmail: yup
      .string(t("forms:validation.email"))
      .email(t("forms:validation.email"))
      .required(t("forms:validation.email")),
    message: yup
      .string(t("forms:validation.messageMin"))
      .required(t("forms:validation.messageRequired"))
      .min(2, t("forms:validation.messageMin")),
  };

  if (state.succeeded) return <Navigate to={localize(paths.contactConfirmation)} />;

  return (
    <div>
      <Form
        className="py-8"
        fields={fields}
        nativeSubmit
        onSubmit={handleSubmit}
        submitText={t("contactUs:submit")}
        validateOnChange={true}
        validations={validations}
      >
        <small className="text-neutral-800">
          <Trans
            i18nKey="contactUs:consent"
            components={{ 1: <Link className="underline" to="/privacy-policy">.</Link> }}
          />
        </small>
      </Form>
    </div>
  );
};

export default ContactUsForm;
